<template>
    <div class="w-full min-h-full flex bg-gray-100">
        <div class="w-full grid bg-white overscroll-none">
            <div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-2 pt-10 px-10">
                <div class="flex flex-col text-left">
                  <span class="text-xl font-bold mt-2 sm:mt-10">{{countDeptorcases}} {{countDeptorcases === 0 || countDeptorcases > 1 ? 'Reclamaciones' : 'Reclamación'}}</span>
                </div>
                <div class="flex flex-col items-end md:pt-4">
                    <router-link to="/debt" class="md:w-60 w-full mt-4 py-2 md:px-6 text-white rounded-md border-2  font-bold" :class="`bg-${colors.primary}-500 hover:bg-${colors.primary}-600`">Nueva reclamación</router-link>
                </div>
            </div>
            <clients-list @onFire="setCountDeptorCases" v-bind:idClient="idClient" :type="'change'" />
            <warning :type_="'change'" />
       </div>
    </div>
</template>

<script lang="ts">
import {reactive, toRefs} from 'vue';
import ClientsList from '@/components/Participant/ClientsList.vue'
import Warning from '@/components/Client/Warning.vue'
import * as global from '@/api/global'
import { getParamUrl } from '@/api/utilities'

export default {
  name: 'ClientArea',
  components: {ClientsList, Warning},

  setup () {

    const state = global.state;
    const { colors } = state.configTenant.template;

    interface debtorCase {
        countDeptorcases: Number
        idClient: Number
    }

    let data = reactive<debtorCase>({
        countDeptorcases: 0,
        idClient: 0,
    })

    const setCountDeptorCases = (item:Number) => {
      data.countDeptorcases = item;
    }

    const getClietIdSession_ = () => {
      data.idClient = global.getClietIdSession();
    }

    if(getParamUrl("code") || getParamUrl("event") || getParamUrl("RETURNMAC")){
      global.routerRedirect()
    }else{
      global.withoutContract();
      global.isExpiredContract();
      getClietIdSession_();
    }
    
     
    return {
     setCountDeptorCases,
     getClietIdSession_,
     global,
     colors,
     ...toRefs(data)
    }

  }
}

</script>
